"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootStoreContext = exports.RootStore = void 0;
const react_1 = __importDefault(require("react"));
const ConsentStore_1 = __importDefault(require("./ConsentStore"));
const ContactAddressStore_1 = __importDefault(require("./ContactAddressStore"));
const ContactFormStore_1 = __importDefault(require("./ContactFormStore"));
const ContactInfoStore_1 = __importDefault(require("./ContactInfoStore"));
const DealerConsentStore_1 = __importDefault(require("./DealerConsentStore"));
const MarketingChannelsStore_1 = __importDefault(require("./MarketingChannelsStore"));
const OnlineHelpEventStore_1 = __importDefault(require("./OnlineHelpEventStore"));
const PublicPrivacyNoticeStore_1 = __importDefault(require("./PublicPrivacyNoticeStore"));
const SsoStore_1 = __importDefault(require("./SsoStore"));
const TranslateStore_1 = __importDefault(require("./TranslateStore"));
const EmailStore_1 = __importDefault(require("./EmailStore"));
const LocationStore_1 = __importDefault(require("./LocationStore"));
const PartyPrivacyProfileStore_1 = __importDefault(require("./PartyPrivacyProfileStore"));
class RootStore {
    constructor() {
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "consentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dealerConsentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initialState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "marketingChannelsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onlineHelpEventStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publicPrivacyNoticeStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contactFormStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "locationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "partyPrivacyProfileStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    init() {
        this.translateStore = new TranslateStore_1.default(this);
        this.locationStore = new LocationStore_1.default(this.translateStore);
        this.ssoStore = new SsoStore_1.default(this);
        this.onlineHelpEventStore = new OnlineHelpEventStore_1.default(this);
        this.marketingChannelsStore = new MarketingChannelsStore_1.default(this);
        this.consentStore = new ConsentStore_1.default(this);
        this.dealerConsentStore = new DealerConsentStore_1.default(this);
        this.contactInfoStore = new ContactInfoStore_1.default(this);
        this.contactAddressStore = new ContactAddressStore_1.default(this);
        this.publicPrivacyNoticeStore = new PublicPrivacyNoticeStore_1.default(this);
        this.contactFormStore = new ContactFormStore_1.default(this);
        this.emailStore = new EmailStore_1.default(this);
        this.partyPrivacyProfileStore = new PartyPrivacyProfileStore_1.default(this);
    }
}
exports.RootStore = RootStore;
exports.default = RootStore;
exports.RootStoreContext = react_1.default.createContext(null);
